import { render, staticRenderFns } from "./hotMajor.vue?vue&type=template&id=1d9abf9b&scoped=true"
import script from "./hotMajor.vue?vue&type=script&lang=js"
export * from "./hotMajor.vue?vue&type=script&lang=js"
import style0 from "./hotMajor.vue?vue&type=style&index=0&id=1d9abf9b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9abf9b",
  null
  
)

export default component.exports